import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import {
  fetchMessages,
  readMessages,
  changeScrollPosition,
} from 'messaging/actions/mailbox';
import { sendMessage } from 'messaging/actions/message';
import { starThread } from 'messaging/actions/thread';
import MessagesHeader from 'messaging/components/MessagesHeader';
import MessageList from 'messaging/components/MessageList';
import NewMessageBar from 'messaging/components/NewMessageBar';

const NoThread = () => (
  <div className="ui icon message">
    <i className="comments icon" />
    <div className="content">
      <div className="header">Aucun utilisateur sélectionné</div>
      <p>Sélectionnez un utilisateur pour voir la conversation.</p>
    </div>
  </div>
);

const Loader = () => (
  <div className="ui segment" style={{ height: '100%' }}>
    <div className="ui active dimmer">
      <div className="ui text loader">Chargement de la discussion</div>
    </div>
  </div>
);

const userFromState = state => state.messaging.mailbox.selectedUser;

const isUserStared = state => {
  const message = state.messaging.threads.messages.get(userFromState(state));
  return (message && message.isStared) || false;
};

const mapStateToProps = state => ({
  isFetching: state.messaging.mailbox.isFetching,
  isSending: state.messaging.mailbox.isSending,
  isReading: state.messaging.mailbox.isReading,
  id: userFromState(state),
  user: state.messaging.recipients.items.get(userFromState(state)),
  messages: state.messaging.mailbox.messages.toArray(),
  scrollPosition: state.messaging.mailbox.scrollPositions.get(
    userFromState(state)
  ),
  isStared: isUserStared(state),
});
const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchMessages: user => dispatch(fetchMessages(user)),
  changeScrollPosition: (user, position) =>
    dispatch(changeScrollPosition(user, position)),
  sendMessage: (message, to) => dispatch(sendMessage(message, [to])),
  readMessages: user => dispatch(readMessages(user)),
  starThread: user => dispatch(starThread(user)),
});
class MessagesPage extends React.Component {
  static propTypes = {
    isFetching: PropTypes.bool,
    isSending: PropTypes.bool,
    isReading: PropTypes.bool,
    id: PropTypes.string,
    user: PropTypes.object,
    messages: PropTypes.array,
    scrollPosition: PropTypes.number,
    isStared: PropTypes.bool.isRequired,
    fetchMessages: PropTypes.func.isRequired,
    readMessages: PropTypes.func.isRequired,
    changeScrollPosition: PropTypes.func.isRequired,
    sendMessage: PropTypes.func.isRequired,
    starThread: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.onRequestNewMessages = this.onRequestNewMessages.bind(this);
    this.onChangeScrollPosition = this.onChangeScrollPosition.bind(this);
    this.onSendMessage = this.onSendMessage.bind(this);
    this.onRequestReadMessages = this.onRequestReadMessages.bind(this);
    this.onStarThread = this.onStarThread.bind(this);
  }

  componentWillMount() {
    this._fetchMessages();
  }

  componentWillReceiveProps(nextProps) {
    const { id } = nextProps;
    if (id && id !== this.props.id) {
      this.props.fetchMessages(id);
    }
  }

  onRequestNewMessages() {
    this._fetchMessages();
  }

  onRequestReadMessages() {
    const { id } = this.props;
    if (id) {
      this.props.readMessages(id);
    }
  }

  onChangeScrollPosition(position) {
    const { id } = this.props;
    if (id) {
      this.props.changeScrollPosition(id, position);
    }
  }

  _fetchMessages() {
    const { id } = this.props;
    if (id) {
      this.props.fetchMessages(id);
    }
  }

  onSendMessage(message) {
    const { id } = this.props;
    if (id) {
      this.props.sendMessage(message, id);
    }
  }

  onStarThread() {
    const { id } = this.props;
    if (id) {
      this.props.starThread(id);
    }
  }

  render() {
    const { user } = this.props;
    if (!user) {
      return <NoThread />;
    }

    const {
      isFetching,
      isSending,
      isReading,
      messages,
      scrollPosition,
      isStared,
    } = this.props;
    if (messages) {
      return (
        <div className="ui segments">
          <MessagesHeader
            user={user}
            isStared={isStared}
            onStar={this.onStarThread}
          />
          <MessageList
            isFetching={isFetching}
            isReading={isReading}
            user={user}
            messages={messages}
            scrollPosition={scrollPosition}
            requestFetch={this.onRequestNewMessages}
            requestRead={this.onRequestReadMessages}
            changeScrollPosition={this.onChangeScrollPosition}
          />
          <NewMessageBar isSending={isSending} onSend={this.onSendMessage} />
        </div>
      );
    }

    return <Loader />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MessagesPage);



// WEBPACK FOOTER //
// ./src/modules/messaging/pages/MessagesPage.js